import queryBox from './queryBox.vue'
export default queryBox
